const appConst = {}

appConst.businessLayer = {
	code: {
		unauthorized: 401,
		badParameters: 422
	}
}

module.exports = appConst



// WEBPACK FOOTER //
// ./src/utils/business/constant/appConstant.js